import React from 'react';
import './Banner.css';

const Banner2 = () => {
  return (
    <section className="banner">
      <div className="banner-container">
        <img src="/kahvebanner2.png" alt="Bulut Ambalaj Banner" className="banner-image" />
      </div>
    </section>
  );
};

export default Banner2;
